// removed by extract-text-webpack-plugin
module.exports = {"base":"InfoTip_base--2ipbb","isOpened":"InfoTip_isOpened--30dQT","overlay":"InfoTip_overlay--3D_uG","infotip":"InfoTip_infotip--2puNn","close":"InfoTip_close--3zde9","inner":"InfoTip_inner--xUCac","bgElement":"InfoTip_bgElement--10e8V","header":"InfoTip_header--3w1js","body":"InfoTip_body--2LA3h","isScrollEnabled":"InfoTip_isScrollEnabled--zBGds","content":"InfoTip_content--2Utgl"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-mt-bootstrap/lib/components/InfoTip/InfoTip.css
// module id = 1805
// module chunks = 16